<div class='card'>
    <div class='card-title'>
        <h4>{{title}}</h4>
        <i class='far fa-times ib-color-text clickable' (click)='onCloseHelp($event)'></i>
    </div>
    <div class='card-body' [innerHTML]='helpString'></div>
</div>
